<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">
              {{ title }}
            </h4>
          </template>
          <template v-slot:headerAction></template>
          <template v-slot:body>
            <p v-html="content"></p>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";

import footerService from "../../services/footer";

export default {
  name: "BlankAuth",
  components: {},
  mounted() {
    xray.index();
    this.getAll();
  },
  computed: {},
  data() {
    return {
      title: "",
      content: "",
      item: [],
    };
  },
  methods: {
    // Footer
    async getAll() {
      let self = this;

      this.$awn.asyncBlock(
        footerService.getAll(),
        (response) => {
          if (response) {
            self.item = response.data;

            let footer = self.getFooterItem(response.data);

            self.title = footer.title.content;
            self.content = footer.content.content;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "footerService.getAll",
            module: "view-authpages-blackAuth",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        },
        " "
      );
    },
    getFooterItem(item) {
      let self = this;

      let footer = null;

      item.footerLanguages.forEach((element) => {
        if (this.$route.query.id == element.content.id) {
          footer = element;
        }
      });

      return footer;
    },
  },
  components: {},
};
</script>
